module.exports = __webpack_public_path__ + "static/personal-solution-10d08d866c548934bfe09f1596c97f13.png";